<template>
    <div>
        <div :class="['page redeem',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content copper">
                <div v-if="coupon" class="coupon">
                    <p style="color: white;font-size: 15px;" >
                        <span style="font-size: 20px">{{ coupon.field }}</span>
                        <span style="font-size: 16px;margin: 6px 0px 10px 0px;">{{ coupon.campaignTitle }}</span>
                        {{ (new Date(coupon.date)+'').split(' GMT')[0] }}
                    </p>
                    <p style="color: white;" ><span style="font-size: 20px;" v-if="coupon.name">{{ coupon.name }}</span><span v-if="coupon.phone">{{ coupon.phone }}</span></p>
                    <img style="width: 40%;margin: 10px 30%" :src="src" />
                    <p v-if="coupon.dateRedeemed" style="color: white; font-size: 15px;" > 
                        <span style="color: white; font-size:15px;">Redeemed Date</span>
                        {{ (new Date(coupon.dateRedeemed)+'').split(' GMT')[0] }}
                    </p>
                    <p style="border:0px" class="btn lg" v-if="coupon.redeemed === false" @click="redeem(coupon)">{{ coupon.redeemAd ? 'REDEEM' : 'ADD CLICK' }}</p>
                </div>
                <div v-else>
                    <p>Redeem Coupon</p>
                    <div v-if="cameraId">
                        <div id="scan-box" style="width: 100%;float:left"></div>
                        <canvas></canvas>
                    </div>
                    <p v-if="cameraId" class="btn" @click="setValue({ k: 'cameraId', value: '' })">change camera</p>
                    <p v-if="!cameraId" v-for="camera in cameras" class="btn" style="line-height: 90px;margin: 40px 15px;" @click="startScen(camera.id)">{{ camera.label }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import Spinner from '@/components/Spinner.vue'

export default {
    name: 'redeem',
    components: {
        VHeader,
        Spinner
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        cameraId() { return this.$store.state.cameraId },
        cameras () { return this.$store.state.cameras },
        processedQuery () { return this.$store.state.processedQuery },
        query () { return this.$store.state.query }
    },
    data () {
        return {
            coupon: '',
            src: '',
            date: Date.now(),
            scanning: false,
            html5QrcodeScanner: false
        }
    },
    watch: { 
        auth ( auth ) {
            auth && this.checkQuery();
        },
        date () {
            var coupon = this.coupon;
            var link = 'https://loyalty-vip.com/redeem?s='+coupon.campaignID+'&c='+coupon.customerID+'&p='+coupon.code+'&i='+coupon.iss+'&d='+this.date;
            this.src = 'https://api.survey-vip.com/qr?id='+encodeURIComponent(link);
        }
    },
    mounted () {
        if ( !this.auth ) return this.pushPage('auth');
        if ( this.query ) return this.getLoyaltyCoupon(this.query);
        if ( !this.$route.query.x && this.cameraId ) return this.startScen();
        if ( !this.$route.query.x ) return;
        !this.processedQuery && this.getLoyaltyCoupon(this.$route.query);
    },
    methods: {
        checkQuery () {
            if ( this.$route.query.x ) {
                this.getLoyaltyCoupon(this.$route.query);
            } else {
                this.cameraId && this.startScen();
            }
        }, 
        getLoyaltyCoupon ( query ) {
            WebSoc.SEND({ t: 'getLoyaltyCoupon', data: { auth: this.auth, query: query }},resp => {
                this.$router.replace('/');
                if ( resp.error ) return Alert.message(resp.error);
                var coupon = resp.coupon;
                if ( coupon ) {
                    this.coupon = coupon;
                    this.date = Date.now();
                }
                this.setValue({ k: 'processedQuery', v: true });
                this.setValue({ k: 'query', v: false });               
            })
        },            
        startScen ( cameraId ) {
            if ( cameraId ) this.setValue({ k: 'cameraId', v: cameraId });
            this.$nextTick(() => {
                this.html5QrcodeScanner = new Html5Qrcode('scan-box',{},false);
                this.html5QrcodeScanner.start(this.cameraId,{ fps: 10, qrbox: 250 },this.getRedeem,e  => {});
            });
        },
        getRedeem ( msg ) {
                //console.log('getRedeem',msg);
            var query = msg.split('?')[1];
                if ( !query ) return;
                query = query.split('&').reduce((prev,fields) => { var fields = fields.split('=');  prev[fields[0]] = fields[1]; return prev; } ,{});
                this.html5QrcodeScanner.stop().then(_ => console.log('stopped')).catch(e => console.log('stop error',e));
                WebSoc.SEND({ t: 'getLoyaltyCoupon', data: { auth: this.auth, query: query } },resp => {
                    //console.log('getLoyalyCoupon resp',resp)
                    var coupon = resp.coupon;
                    if ( coupon ) {
                        this.coupon = coupon;
                        this.date = Date.now();
                    }    
                });           
        },
        back () {
            this.pageOn = false;
            this.html5QrcodeScanner && this.html5QrcodeScanner.stop().then(_ => console.log('stopped')).catch(e => console.log('stop error',e));
        },
        redeem ( coupon ) {
            WebSoc.SEND({ t: 'redeemLoyaltyCoupon', data: { coupon, query: this.$route.query, auth: this.auth }},resp => {
                console.log('redeemLoyaltyCoupon resp',JSON.parse(JSON.stringify(resp)));
                if ( resp.clicked ) {
                    Alert.message('Click Added');
                    this.back();
                }
                if ( resp.update ) {    
                    this.coupon.status = 'Redeemed'; 
                    this.coupon.redeemed = true; 
                    this.date = Date.now(); 
                    Alert.message('Coupon Redeemed');
                }
                if ( resp.error ) Alert.message(resp.error);
            })
        },
        ...mapMutations(['setValue','pushPage'])
    }
}
</script>

<style lang="scss">
.page.redeem {
    .coupon {
        > p { width: 90%; margin: 10px 5%; float: left; text-align: center; font-size: 20px; border: 1px solid white; padding: 10px 0px; }
        > p span { width: 100%; float: left; text-align: center; font-size: 15px; }
        .field-list {
            width: calc(90% - 50px); float: left; margin: 10px calc(5% + 25px); border: 1px solid white;
            padding: 10px 0px;
            p { margin: 5px 10px; float: left; width: calc(100% - 20px); span { float: right; } }
        }
    }
}
</style>